document.addEventListener('DOMContentLoaded',()=>{
  const drawer=document.querySelector('[data-mobile-drawer]');
  const open=document.querySelector('[data-mobile-open]');
  const closes=document.querySelectorAll('[data-mobile-close]');
  const setOpen=(value)=>{if(!drawer)return;drawer.classList.toggle('is-open',value);drawer.setAttribute('aria-hidden',String(!value));document.body.classList.toggle('drawer-open',value);if(open)open.setAttribute('aria-expanded',String(value));};
  if(open)open.addEventListener('click',()=>setOpen(true));
  closes.forEach(el=>el.addEventListener('click',()=>setOpen(false)));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')setOpen(false)});
  document.querySelectorAll('[data-quantity-change]').forEach(button=>button.addEventListener('click',()=>{
    const input=document.getElementById(button.dataset.input);if(!input)return;
    const delta=Number(button.dataset.quantityChange);const min=Number(input.min||0);input.value=Math.max(min,Number(input.value||0)+delta);input.dispatchEvent(new Event('change',{bubbles:true}));
  }));
});
